import hocTap1 from "../../../assets/images/HocTap/1.png";
import hocTap2 from "../../../assets/images/HocTap/2.png";
import hocTap3 from "../../../assets/images/HocTap/3.png";
import hocTap4 from "../../../assets/images/HocTap/4.png";
import hocTap5 from "../../../assets/images/HocTap/5.png";
const BanHocTap = {
  title: "Ban",
  name: "Học Tập",
  registerMes:
    "Bấm đăng kí để có cơ hội trở thành thành viên của ban học tập nhé",
  clb: "student informatic club",
  btn: "Đăng kí CTV",
  imagesIntro: [hocTap1, hocTap2, hocTap3, hocTap4, hocTap5],
  mission: [
    `Xây dựng kế hoạch và tổ chức thực hiện các hoạt động nhằm hỗ
    trợ, thúc đẩy tinh thần học tập của sinh viên`,
    `Tổ chức các buổi sinh hoạt, buổi học tập theo yêu cầu nhằm
    giúp sinh viên nâng cao trình độ`,
    `Hỗ trợ giải đáp thắc mắc của sinh viên trong quá trình học tập`,
  ],
  advantage: [
    `Nâng cao kiến thức, hoàn thiện bản thân`,
    `Trau dồi khả năng tổ chức và lên kế hoạch`,
    `Rèn luyện tinh thần học hỏi, tinh thần trách nghiệm`,
    `"Level up" khả năng diễn đạt và truyền tải kiến thức`,
    `Có cơ hội được tiếp xúc với nhiều học sinh sinh viên từ những chuyên ngành khác nhau`,
  ],
};

export default BanHocTap;
